/**
 * Props that suppress the browser's native autofill / autocomplete dropdown
 * and third-party password-manager overlays on custom autocomplete/combobox
 * inputs.
 *
 * Our typeahead components (airline, airport, city, hotel, restaurant, venue,
 * FBO, speaker, etc.) render their own suggestion dropdown directly below the
 * input. When the browser also shows its saved-values dropdown (e.g. names,
 * addresses) it overlaps and obscures our list, breaking the UX. Spreading
 * these props onto the input tells the browser and password managers to leave
 * the field alone.
 *
 * Usage:
 *   import { noAutofillProps } from '../../utils/noAutofill';
 *   <input {...noAutofillProps} ... />
 *
 * Note: pass a distinct, non-standard `name` per input as well (Chrome keys its
 * autofill heuristics off field name/label, and a recognizable name like
 * "name"/"city" can re-enable autofill even with autoComplete="off"). The
 * `name` defaults here to "search" but callers may override it.
 */
export const noAutofillProps = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
  // Password-manager opt-out signals (1Password, LastPass, Dashlane, Bitwarden)
  'data-1p-ignore': true,
  'data-lpignore': true,
  'data-bwignore': true,
  'data-form-type': 'other',
};

export default noAutofillProps;
